import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-[750px] min-h-svh flex flex-col justify-center pt-24 md:pt-20" data-id="element-245">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-246">
        <img src="https://cdn.shopify.com/s/files/1/0740/9788/5319/files/IMG-20260606-WA0000.jpg?v=1780717082" alt="Flash & Go Showroom" className="w-full h-full object-cover object-center" data-id="element-247" />
        <div className="absolute inset-0 bg-black/60" data-id="element-248"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 w-full flex-grow flex flex-col justify-center pb-10 md:pb-32" data-id="element-249">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl" data-id="element-250">
          <h1 className="font-heading text-7xl md:text-8xl lg:text-9xl leading-[0.85] mb-6" data-id="element-251">
            <span className="text-brand-white block" data-id="element-252">COMPRÁ, ALQUILÁ</span>
            <span className="text-brand-gold block" data-id="element-253">O INVERTÍ.</span>
          </h1>

          <p className="text-xl md:text-2xl text-brand-white/90 font-light mb-12" data-id="element-254">
            Tu capital sobre ruedas.
          </p>

          <div className="flex flex-col items-stretch gap-3 max-w-[280px] mx-auto sm:max-w-none sm:mx-0 sm:flex-row sm:flex-wrap sm:gap-4" data-id="element-255">
            <button onClick={() => scrollToSection('compra-venta')} className="px-8 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors text-center" data-id="element-256">
              Comprar un auto
            </button>
            <button onClick={() => scrollToSection('alquiler')} className="px-8 py-4 border-2 border-brand-gold text-brand-gold font-bold rounded hover:bg-brand-gold hover:text-brand-black transition-colors text-center" data-id="element-257">
              Alquilar para apps
            </button>
            <button onClick={() => scrollToSection('consignacion')} className="px-8 py-4 border-2 border-brand-gold text-brand-gold font-bold rounded hover:bg-brand-gold hover:text-brand-black transition-colors text-center" data-id="element-258">
              Dejar en consignación
            </button>
            <a href="https://project-flash-and-go-investor-landing-page-109.magicpatterns.app" className="px-8 py-4 border-2 border-brand-gold text-brand-gold font-bold rounded hover:bg-brand-gold hover:text-brand-black transition-colors text-center" data-id="element-259">
              Invertir
            </a>
          </div>
        </motion.div>
      </div>

      {/* Stats Bar */}
      <div className="relative md:absolute md:bottom-0 left-0 right-0 z-20 bg-brand-black/80 backdrop-blur-md border-t border-brand-gold/30" data-id="element-260">
        <div className="max-w-7xl mx-auto px-5 sm:px-6" data-id="element-261">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-px md:divide-x md:divide-brand-gold/20" data-id="element-262">
            {[{
            title: 'Compra y Venta',
            desc: 'Autos 0km y usados'
          }, {
            title: 'Alquiler para Apps',
            desc: 'Uber, Cabify y más'
          }, {
            title: 'Financiación',
            desc: 'Hasta el 100%'
          }, {
            title: '2% mensual',
            desc: '24% anual en dólares'
          }].map((stat, i) => <div key={i} className="py-5 md:py-6 px-3 md:px-4 text-center" data-id="element-263">
                <h3 className="font-heading text-2xl text-brand-gold mb-1" data-id="element-264">
                  {stat.title}
                </h3>
                <p className="text-sm text-brand-white/70" data-id="element-265">{stat.desc}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}